import React from 'react';

type Props = {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmModal({ title, message, onConfirm, onCancel }: Props) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon">?</div>
        <div className="modal-title">{title}</div>
        <div className="modal-subtitle">{message}</div>
        <div className="modal-actions">
          <button className="btn btn-danger" onClick={onConfirm}>YES, DELETE</button>
          <button className="btn btn-ghost" onClick={onCancel}>CANCEL</button>
        </div>
      </div>
    </div>
  );
}
